import { useMemo, useState } from "react"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { FilterButton } from "@l2r-front/l2r-ui"

import { FILTERS } from "../../constants/filters"
import { useRoadworksStateContext } from "../../contexts/RoadworksContext/RoadworksContext.hooks"
import { roadworksFiltersConfig } from "../../utils/roadworksFiltersConfig"

import { TechniquesFilters } from "../TechniquesFilters"

export function RoadworksFilterButton(props) {

    const {
        className,
        enabledFilters,
    } = props

    const [displayFilters, setDisplayFilters] = useState(false)
    const closeFilters = () => setDisplayFilters(false)
    const toggleFilter = () => setDisplayFilters(displayFilters => !displayFilters)

    const { filters } = useRoadworksStateContext()

    const filterCount = useMemo(() => {
        return Object.entries(filters || {}).map(([filterKey, filterValue]) => {
            if (enabledFilters.includes(filterKey)) {
                return roadworksFiltersConfig?.[filterKey]?.getValueList(filterKey, filterValue)
            } else {
                return []
            }
        }).flat().length
    }, [filters, enabledFilters])

    return <FilterButton className={className} filterCount={filterCount} open={displayFilters} onClick={toggleFilter} onClose={closeFilters}>
        <TechniquesFilters close={closeFilters} displayFilters={displayFilters} />
    </FilterButton>
}

RoadworksFilterButton.defaultProps = {
    enabledFilters: FILTERS,
}

RoadworksFilterButton.propTypes = {
    className: PropTypes.string,
    enabledFilters: PropTypes.arrayOf(PropTypes.oneOf(FILTERS)),
}